import React, { useEffect, useState } from 'react';
import { Offcanvas, Card } from 'react-bootstrap';
import { fetchConToken } from '../../api/fetch';
import { getLetters, htmlTxt } from '../../helpers/details';
const baseUrl = process.env.REACT_APP_API;

const OffCanvasTk = ({ show, toggle, data }) => {
    const { id = 0 } = data;
    const [tks, setTkts] = useState([]);
    useEffect(() => {
        getTks();
    }, [id]);
    const getTks = async () => {
        const res = await fetchConToken(`tickets/ticket/${id}`);
        if (res.ok) setTkts(res.data);
    };
    return (
        <Offcanvas show={show} onHide={toggle} scroll={true} backdrop={true}>
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>
                    {' '}
                    <b className="mx-2 text-primary">Ticket</b>
                    <span>
                        {'#000'}
                        {data.id}
                    </span>
                </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                {tks.map((tk) => (
                    <div className="mb-2" key={tk.id}>
                        <Card className="p-2">
                            <span className="fs-6 ">{tk.fecha_hora}</span>

                            <div className="d-flex ">
                                {' '}
                                <span className="account-user-avatar m-2">
                                    <div className="avatar-xs">
                                        <span className="avatar-title  text-white font-10 rounded-circle">
                                            {' '}
                                            {tk.state === 1 ? getLetters(tk.agente) : getLetters(data.cliente)}
                                        </span>
                                    </div>
                                </span>
                                <div className="">
                                    <div className="text-info">
                                        <b>{tk.state === 1 ? tk.agente : data.cliente}</b>
                                    </div>

                                    <p className="font-bold w-36  text-justify text-ssm text-black dark:text-white pr-2 ">
                                        {htmlTxt(tk.contenido)}
                                    </p>
                                    {tk.adjunto && (
                                        <img
                                            src={`${baseUrl}${tk.adjunto}`}
                                            alt="adjuntoTk"
                                            style={{ width: '50px' }}
                                        />
                                    )}
                                </div>
                            </div>
                            <span className="fs-5 text-info">{tk.state === 0 ? 'Cliente' : 'Agente'}</span>
                        </Card>
                    </div>
                ))}
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default OffCanvasTk;
